/**
 * Vendors filter pill. Extracted from Vendors.jsx (Feb 2026 refactor).
 */

export function FilterChip({ value, label, active, onClick }) {
  return (
    <button
      data-testid={`vendors-filter-${value}`}
      onClick={onClick}
      className={`px-3 py-1.5 text-xs rounded-full border transition-colors ${
        active
          ? "bg-[var(--accent)] text-black border-[var(--accent)] font-semibold"
          : "border-[var(--border-color)] text-[var(--text-secondary)] hover:bg-[var(--surface-hover)]"
      }`}
    >
      {label}
    </button>
  );
}
